import "../chunk-XTU7I5IS.js";
import { buildErrorThrower } from "@clerk/shared/error";
const errorThrower = buildErrorThrower({ packageName: "@clerk/react" });
function __internal__setErrorThrowerOptions(options) {
  errorThrower.setMessages(options).setPackageName(options);
}
export {
  __internal__setErrorThrowerOptions,
  errorThrower
};
//# sourceMappingURL=errorThrower.js.map